export default "__VITE_ASSET__DuzouHtc__"